import {orderBy, uniqBy, keyBy} from 'lodash';
import uniqid from 'uniqid';
import { words, truncate } from 'lodash';
import {formatSlackResult, getSlackMessageAttachments, getUserName} from './slack';
import {formatGmailResult, getGmailAttachments, normalizeGmailResult} from './gmail';
import {
  extractSnippet,
  formatJiraComments, formatJiraText,
  highlightAndLink,
  highlightAndLinkText,
  highlightSearchTerm
} from './various';
import mime from 'mime';
import ReactHtmlParser from 'react-html-parser';
import structureOfficeResult from './office';

const DEACTIVATED_USER = 'Deactivated user';
const NO_PREVIEW_AVAILABLE = 'No preview available. Click here to check the content.';
const NO_CONTENT_AVAILABLE = 'No content available.'

export const slackResult = [{
  "blocks":[
    {
      "block_id":"26EA",
      "elements":[
        {
          "elements":[
            {
              "text":"Hello Everyone,\nA Globus endpoint has been stood up for the HAL cluster at NCSA, it can be found at ncsa#hal via the Globus web interface.  This endpoint will help facilitate transfers of large datasets between Globus enabled systems or between HAL and your personal machine.  If you wish to install Globus on your laptop or workstation instructions to do so can be found here: ",
              "type":"text"
            },
            {
              "type":"link",
              "url":"https://www.globus.org/globus-connect-personal"
            }
          ],
          "type":"rich_text_preformatted"
        },
        {
          "elements":[

          ],
          "type":"rich_text_section"
        }
      ],
      "type":"rich_text"
    }
  ],
  "client_msg_id":"0b6ce9d9-85ae-47fb-9e88-8310e7b29ca7",
  "conversation_id":"C017ZANKF2Q",
  "filter":"message",
  "platform":"slack",
  "rank":4,
  "team":"TFJRA9CDV",
  "text":"```Hello Everyone,\nA Globus endpoint has been stood up for the HAL cluster at NCSA, it can be found at ncsa#hal via the Globus web interface.  This endpoint will help facilitate transfers of large datasets between Globus enabled systems or between HAL and your personal machine.  If you wish to install Globus on your laptop or workstation instructions to do so can be found here: \u003chttps://www.globus.org/globus-connect-personal\u003e```\n",
  "ts":"1595869754.010400",
  "type":"message",
  "user":"UM8V4B078"
}]
export const jiraTicketData = [{
  assignee: null,
  assignee_avatar: 'https://avatar-management--avatars.us-west-2.prod.public.atl-paas.net/609580b9a56f2f006f66d490/f524b833-ff1d-4120-8fe6-b00ae740cc78/16',
  created_timestamp: '2021-09-20T17:54:12.418+0000',
  duedate: '2021-10-15',
  issuetype: {
    "description": "A big user story that needs to be broken down. Created by Jira Software - do not edit or delete.",
    "hierarchyLevel": 1,
    "iconUrl": "https://gotrova.atlassian.net/images/icons/issuetypes/epic.svg",
    "id": "10000",
    "name": "Epic",
    "self": "https://api.atlassian.com/ex/jira/982073db-3140-4cce-8f54-ac6d7d74ecb4/rest/api/2/issuetype/10000",
    "subtask": false
  },
  priority: {
    "iconUrl": "https://gotrova.atlassian.net/images/icons/priorities/highest.svg",
    "id": "1",
    "name": "Highest",
    "self": "https://api.atlassian.com/ex/jira/982073db-3140-4cce-8f54-ac6d7d74ecb4/rest/api/2/priority/1"
  },
  project: 'webapp',
  project_avatar: 'https://api.atlassian.com/ex/jira/982073db-3140-4cce-8f54-ac6d7d74ecb4/rest/api/2/universal_avatar/view/type/project/avatar/10424?size=xsmall',
  creator: 'Holly Chen',
  creator_avatar: 'https://avatar-management--avatars.us-west-2.prod.public.atl-paas.net/609580b9a56f2f006f66d490/f524b833-ff1d-4120-8fe6-b00ae740cc78/16',
  summary: '10/15 release WEB bug fixes',
  issue_key: 'WEB-296',
  issue_url: 'https://gotrova.atlassian.net/browse/WEB-296',
},
  {
  assignee: 'Valentin Zuld',
  assignee_avatar: 'https://secure.gravatar.com/avatar/377092161fe23e2bcfbcd6650635b373?d=https%3A%2F%2Favatar-management--avatars.us-west-2.prod.public.atl-paas.net%2Finitials%2FVZ-4.png',
  created_timestamp: '2021-09-20T17:54:12.418+0000',
  duedate: null,
  issuetype: {
    "avatarId": 10303,
    "description": "A problem or error.",
    "hierarchyLevel": 0,
    "iconUrl": "https://api.atlassian.com/ex/jira/982073db-3140-4cce-8f54-ac6d7d74ecb4/rest/api/2/universal_avatar/view/type/issuetype/avatar/10303?size=medium",
    "id": "10005",
    "name": "Bug",
    "self": "https://api.atlassian.com/ex/jira/982073db-3140-4cce-8f54-ac6d7d74ecb4/rest/api/2/issuetype/10005",
    "subtask": false
  },
  priority: {
    "iconUrl": "https://gotrova.atlassian.net/images/icons/priorities/highest.svg",
    "id": "1",
    "name": "Highest",
    "self": "https://api.atlassian.com/ex/jira/982073db-3140-4cce-8f54-ac6d7d74ecb4/rest/api/2/priority/1"
  },
  project: 'webapp',
  project_avatar: 'https://api.atlassian.com/ex/jira/982073db-3140-4cce-8f54-ac6d7d74ecb4/rest/api/2/universal_avatar/view/type/project/avatar/10424?size=xsmall',
  creator: 'Lijian Wang',
  creator_avatar: 'https://secure.gravatar.com/avatar/1f4cd58a9b32a415c4ba5eee28aff9e8?d=https%3A%2F%2Favatar-management--avatars.us-west-2.prod.public.atl-paas.net%2Finitials%2FLW-3.png',
  summary: 'going to bookmark page will crash the page ',
  issue_key: 'WEB-253',
  issue_url: 'https://gotrova.atlassian.net/browse/WEB-253',
}]

interface Subscription {
  platform: string;
  email?: string;
  teamID?: string;
  teamName?: string;
  channels?: Array<object>;
  gmail_account?: string;
  team_id?: string;
  channel_id?: string;
  members?: Array<object>;
  token_status?: string;
  teams_token_status?: string;
  teams?: boolean;
  o365?: boolean;
  conversations?: object;
}

interface SubscriptionData {
  slack?: object | any;
  gmail?: object | any;
  gdrive?: object | any;
  jira?: object | any;
  outlook?: object | any;
  dropbox?: object | any;
  teams?: object | any;
}

export let subscriptionsData:SubscriptionData = {};

export const normalize: Object | any = {
  gmail: (data: Array<object>) => {
    return data.map(d => ({
      ...d,
      platform: 'gmail'
    }));
  },
  gmail_original: (data: Array<object>) => {
    return data.map(d => ({
      ...d,
      platform: 'gmail'
    }));
  },
  slack: (data: Array<object>) => {
    return data.map(d => ({
      ...d,
      platform: 'slack'
    }));
  },
  slack_original: (data: Array<object>) => {
    return data.map(d => ({
      ...d,
      platform: 'slack'
    }));
  },
  slack_entity: (data: Array<object>) => {
    return data.map(d => ({
      ...d,
      platform: 'slack'
    }));
  },
  gdrive_original: (data: Array<object>) => {
    return data.map((d: any) => ({
      ...d,
      title: d.filename,
      account: d.gdrive_account,
      file: d.filename,
      platform: 'gdrive'
    }));
  },
  outlook_original: (data: Array<object>) => {
    return data.map((d: any) => ({
      ...d,
      platform: 'outlook',
      title: d.title,
      date: d.received_time,
      permalink: d.email_url,
    }))
  },
  jira_original: (data: Array<object>) => {
    return data.map((d: any) => ({
      ...d,
      platform: 'jira',
      title: d.title,
      date: d.received_time,
      permalink: d.email_url,
    }));
  },
  dropbox_original: (data: Array<object>) => {
    return data.map((d: any) => ({
      ...d,
      title: d.name,
      permalink: d.url,
      platform: 'dropbox'
    }));
  },
  teams: (data: Array<object>) => {

  }
}

const formatSlackMessage = {
  conv: (msg:any, sub:any, rank:number, highlight: string[]) => {
    const def = {
      teamName: '',
      channelName: '',
      resultText: '',
      resultSnippet: '',
      user: '',
      att: getSlackMessageAttachments(msg.message),
      rank,
      ts: msg.ts,
    }

    if (sub.channels && sub.channels.length) {
      const channel = sub.channels.find((ch:any) => ch.conversation_id === msg.conversation_id);
      const team = sub.channels.find((ch:any) => ch.team_id === msg.teamID);
      def.channelName = channel?.channel_name || msg.conversation_id;
      def.teamName = team.team_name || sub.team_name;
    }
    def.user = getUserName(msg.message?.user, sub.members);
    if (!def.user){
      if (msg.message && msg.message.user_profile) {
        def.user = msg.message.user_profile.real_name;
      } else {
        def.user = DEACTIVATED_USER;
      }
    }
    if (msg.message) {
      const { text } = msg.message;
      const formattedMessage:any = formatSlackResult(text, sub.members, sub.channels, def.channelName, highlight);
      def.resultText = formattedMessage.text;
      def.resultSnippet = formattedMessage.snippet;
    }
    return def;
  },
  msg: (data:any, sub:any, highlight: string[]) => {
    const def = {
      teamName: '',
      channelName: '',
      resultText: '',
      resultSnippet: '',
      user: DEACTIVATED_USER,
      att: getSlackMessageAttachments(data.message),
      rank: data.rank,
      ts: data.message.ts,
    }
    if (sub.channels && sub.channels.length) {
      const channel = sub.channels.find((ch:any) => ch.conversation_id === data.conversation_id);
      const team = sub.channels.find((ch:any) => ch.team_id === data.teamID);
      def.channelName = channel?.channel_name || '';
      def.teamName = team.team_name || sub.team_name || '';
    }
    let messageText = '';
    if (data.message) {
      const { text, user_profile, subtype } = data.message;
      if (text) {
        messageText = text;
      }
      if (subtype === 'bot_message' && data.message.attachments) {
        messageText = data.message.attachments.map((att:any) => {
          if (att.pretext || att.text) {
            def.user = att.author_name ? att.author_name : def.user;
            return [
              att.pretext,
              att.text,
            ]
          }
          def.user = def.user || att.author_name;
          return [att.fallback];
        }).flat().join(' \n');

        if (!def.user) {
          def.user = getUserName(data.message.bot_id, sub.members) || 'SLACKBOT';
        }
      } else {
        def.user = getUserName(data.message.user, sub.members);
      }

      if (!def.user) {
        if (user_profile) {
          def.user = user_profile.real_name;
        } else {
          def.user = DEACTIVATED_USER;
        }
      }
    }
    const formattedMessage:any = formatSlackResult(messageText, sub.members, sub.channels, def.channelName, highlight);
    def.resultSnippet = formattedMessage.snippet;
    def.resultText = formattedMessage.text;
    return def;
  },
  txt: (data:any, sub:any, highlight:string[]) => {
    const def = {
      teamName: '',
      channelName: data.channel ? data.channel.name : '',
      resultText: '',
      resultSnippet: '',
      user: sub.members.find((m:any) => m.user_id === data.user)?.real_name || DEACTIVATED_USER,
      rank: data.rank,
      ts: data.ts,
    }
    if (sub.channels && sub.channels.length) {
      const team = sub.channels.find((ch:any) => ch.team_id === data.team);
      if (team) {
        def.teamName = team.team_name || sub.team_name;
      }
    }
    if (data.user_profile) {
      def.user = data.user_profile.real_name;
    } else {
      def.user = getUserName(data.user, sub.members);
    }
    let formattedMessage:any;
    if (data.subtype === 'bot_message' && data.attachments) {
      const messageText = data.attachments.map((att:any) => {
        if (att.pretext || att.text) {
          def.user = att.author_name ? att.author_name : def.user;
          return [
            att.pretext,
            att.text,
          ]
        }
        return [att.fallback];
      }).flat().join(' \n');
      formattedMessage = formatSlackResult(messageText, sub.members, sub.channels, def.channelName, highlight)
      if (!def.user) {
        def.user = getUserName(data.bot_id, sub.members) || 'SLACKBOT';
      }
    } else {
      formattedMessage = formatSlackResult(data?.text, sub.members, sub.channels, def.channelName, highlight);
    }
    def.resultText = formattedMessage.text;
    def.resultSnippet = formattedMessage.snippet;
    return def;
  }
}

const normalizeSlackMessages = (data: any, sub: any, highlight: string[]) => {
  const messages:Array<any> = [];
  if (data.conv_msgdata) {
    data.conv_msgdata.forEach((msg:any) => {
      messages.push(
        formatSlackMessage.conv(msg, sub, data.rank, highlight)
      )
    });
  } else if (data.message) {
    messages.push(
      formatSlackMessage.msg(data, sub, highlight)
    )
  } else {
    messages.push(formatSlackMessage.txt(data, sub, highlight))
  }
  return messages;
}
const getSlackChannelName = (data: any, sub:any, conversation_id:any) => {
  if (data.channelDisplayName) {
    return data.channelDisplayName;
  }
  let name = '';
  if (!sub.channels || !sub.channels.length) {
    return name;
  }
  const channel = sub.conversations[conversation_id] || sub.channels.find((ch:any) => ch.conversation_id === conversation_id);
  if (channel) {
    name = channel.channel_name || '';
  }

  return name;
}
const getSlackData = (data:any, highlight: string[]) => {
  const { conversation_id, team } = data;
  const timestamp = data.ts || data.match_ts;
  const date = timestamp ? new Date(timestamp * 1000).toLocaleString() : '';
  let sub;
  if (team) {
    sub = subscriptionsData.slack?.find((s:any) => s.team_id === team) || {};
  } else {
    sub = subscriptionsData.slack[0] || {};
  }
  sub.members = subscriptionsData.slack?.map((s:any) => {
    if (s.allMembers && s.allMembers.length) {
      return s.allMembers
        .map((teams:any) => {
          return teams.users;
        })
        .flat()
    }
    return [];
  }).flat() || [];
  const messages = normalizeSlackMessages(data, sub, highlight);
  const teamDisplayName = data.teamDisplayName || sub?.team_name;
  const channelDisplayName = getSlackChannelName(data, sub, conversation_id);
  return {
    ...data,
    date,
    sender: messages ? messages[data.match_pos || 0].user : '',
    pl: 'slack',
    teamDisplayName,
    channelDisplayName,
    sub,
    timestamp,
    messages,
    related: {
      jira: data.jira_tickets && data.jira_tickets.length
        ? data.jira_tickets.map((td:any) => {
          return {
            ...td,
            summary: highlightSearchTerm(td.summary, highlight),
            pl: 'jira'
          }
        })
        : null
    }
  }
}

const normalizeArr: Object | any = {
  gmail_entity: (data: any, highlight: string[]) => {
    const att = getGmailAttachments(data);
    let snip = data.snippet.length > 220 ? truncate(data.snippet, { length: 220 }) : data.snippet + '...';
    if (!data.snippet || !words(data.snippet).length) {
      if (!att.length) {
        snip = NO_PREVIEW_AVAILABLE;
      }
    }
    let sender = data.sender_name || '';
    if (data.sender_email) {
      sender = `${sender} <${data.sender_email}>`
    }
    if (sender) {
      sender = sender.replace(/"/g, '')
    }
    return {
      ...data,
      title: data.subject,
      sender,
      resultSnippet: highlightAndLink(snip, highlight),
      fullMessage: formatGmailResult(data, highlight) || NO_CONTENT_AVAILABLE,
      pl: 'gmail',
      att: getGmailAttachments(data),
      date: data.timestamp ? new Date(+data.timestamp).toLocaleString() : ''
    }
  },
  gmail_original: (data: any, highlight: string[]) => {
    const att = getGmailAttachments(data);
    let snip = data.snippet.replace(/\u200C/g, '')
    snip = snip.length > 220 ? truncate(snip, { length: 220 }) : snip + '...';
    if (!snip || !words(snip).length) {
      if (!att.length) {
        snip = NO_PREVIEW_AVAILABLE;
      }
    }
    const fullMessage = formatGmailResult(data, highlight);
    return {
      ...data,
      title: highlightSearchTerm(data.title, highlight),
      sender: data.sender ? data.sender.replace(/"/g, '') : '',
      resultSnippet: highlightAndLink(snip, highlight),
      fullMessage: fullMessage || NO_CONTENT_AVAILABLE,
      //fullFetched: !!fullMessage,
      pl: 'gmail',
      att,
      date: data.timestamp ? new Date(+data.timestamp).toLocaleString() : ''
    }
  },
  gmail: normalizeGmailResult,
  slack: getSlackData,
  slack_original: getSlackData,
  slack_entity: getSlackData,
  gdrive_original: (data: any, highlight: string[]) => {
    let mimeType = null;
    if (data.webViewLink) {
      const linkParts = data.webViewLink.split('/');
      if (['document', 'spreadsheets', 'presentation'].indexOf(linkParts[3]) > -1) {
        mimeType = `gdrive/${linkParts[3]}`;
      }
    }

    return {
      ...data,
      title: highlightSearchTerm(data.name, highlight),
      filename: data.name,
      account: data.gdrive_account,
      file: data.name,
      url: data.webViewLink,
      date: new Date(data.modifiedTime).toLocaleString(),
      mimeType: mimeType || mime.getType(data.filename || data.originalFilename),
      permalink: data.webViewLink,
      pl: 'gdrive'
    };
  },
  gdrive: (data: any, highlight: string[]) => {
    return normalizeArr.gdrive_original(data, highlight);
  },
  jira: (data: any, highlight: string[]) => {
    const { fields } = data;
    const { issuetype, description, status, assignee, reporter, project, priority } = fields;
    let jiraLink = data.self.split('/').slice(0, 3);
    let issueParent = null;
    if (priority && priority.iconUrl) {
      jiraLink = priority.iconUrl.split('/').slice(0, 3);
    }
    let issueLink = [...jiraLink];
    issueLink.push('browse');
    issueLink.push(data.key);
    let issueDescription = description ? description.replace(/!.*!/gm, '') : '';
    issueDescription = formatJiraText(issueDescription);
    let issueSnippet:any = extractSnippet(highlightAndLinkText(issueDescription, highlight) || NO_CONTENT_AVAILABLE, 220);
    issueSnippet = ReactHtmlParser(issueSnippet);
    issueDescription = ReactHtmlParser(highlightAndLinkText(issueDescription, highlight) || NO_CONTENT_AVAILABLE);
    if (fields.comment && fields.comment.comments.length) {
      fields.comment.comments = formatJiraComments(fields.comment.comments);
    }
    if (fields.parent && fields.parent.fields?.issuetype?.name === 'Epic') {
      const parentFields = { ...fields.parent.fields };
      const parentLink = [...jiraLink];
      parentLink.push('browse');
      parentLink.push(fields.parent.key);
      issueParent = {
        name: parentFields.summary,
        link: parentLink.join('/'),
        iconUrl: parentFields.issuetype.iconUrl,
      }
    }
    return {
      ...data,
      pl: 'jira',
      snippet: issueSnippet,
      description: issueDescription,
      issueTypeName: issuetype.name || '',
      issueLink: issueLink.join('/'),
      issueParent,
      statusName: status.name || '',
      assigneeName: assignee ? assignee.displayName : '',
      reporterName: reporter ? reporter.displayName : '',
      projectName: project.name || '',
      priorityName: priority.name || '',
      att: fields.attachment ? fields.attachment.map((at:any) => {
        let filename = at.filename;
        if (!filename) {
          const parts = at.content.split('/');
          filename = parts[parts.length - 1];
        }
        return {
          ...at,
          filename,
          url: issueLink.join('/'),
          mimeType: at.mimeType || mime.getType(filename)
        };
      }) : [],
      jiraLink: jiraLink.join('/'),
      title: highlightSearchTerm(fields.summary, highlight),
      date: fields.updated ? new Date(fields.updated).toLocaleString() : new Date(fields.created).toLocaleString(),
      permalink: issueLink.join('/'),
    };
  },
  dropbox: (data: any, highlight: string[]) => {
    let pathParts = data.path.split('/').slice(1);
    if (!pathParts.length) {
      pathParts.push(data.name);
    }
    const itemPath = highlightSearchTerm(pathParts.join(' > '), highlight);
    const linkPath = pathParts.join('/');
    let date = '';
    if (data.client_modified) {
      date = new Date(data.client_modified).toLocaleString()
    } else {
      date = data.shared && data.time_invited ? new Date(data.time_invited).toLocaleString() : '';
    }

    return {
      ...data,
      title: highlightSearchTerm(data.name, highlight),
      filename: data.name,
      permalink: data.url,
      itemPath,
      linkPath,
      pl: 'dropbox',
      mimeType: mime.getType(data.name),
      date,
    };
  },
  'office-365': structureOfficeResult,
}

export const normalizeSearchResults = (data: object | any) => {
  const keys = Object.keys(data).filter(k => !!normalizeArr[k]).sort();
  const results = keys
    .map((k:any) => {
      return data[k].map((d:any) => {
        return {
          displayId: uniqid(),
          ...normalizeArr[k](d, data.highlight)
        }
      })
    })
    .flat()
  return orderBy(uniqBy(results, (value) => {
    if (value.pl === 'gmail') {
      return `${value.msg_id}-${value.email}`;
    }
    if (value.pl === 'slack') {
      return `${value.team_id}-${value.conversation_id}-${value.timestamp}`
    }
    return value.result_id;
  }), 'rank', 'asc')
}

export const normalizeResultsArr = (data: Array<any>, highlight?: string[]) => {
  return data
    .filter(d => !!normalizeArr[d.platform])
    .sort((a, b) => {
      if (!a.rank) return 1;
      if (a.rank > b.rank) return 1;
      if (a.rank < b.rank) return -1;
      return 0
    })
    .map(d => normalizeArr[d.platform](d, highlight));
}

export const normalizePagedResults = (data: object | any, highlights: string[]) => {
  let firstSlack:any = -1;
  const normalized = [ ...data ]
    .filter((res:any) => !res.error)
    .map((result:any) => {
      if (!result.platform && result.dropbox_account) {
        result.platform = 'dropbox';
      }
      if (!normalizeArr[result.platform]) {
        return null;
      }

      return {
        displayId: uniqid(),
        ...normalizeArr[result.platform](result, highlights, firstSlack),
      }
    })
    .filter((res:any) => res);
  return orderBy(uniqBy(normalized, (value:any) => {
    if (value.result_id) {
      return value.result_id;
    }
    if (value.pl === 'gmail') {
      return `${value.msg_id}-${value.email}`;
    }
    if (value.pl === 'slack') {
      return `${value.team_id}-${value.conversation_id}-${value.timestamp}`
    }
    // TODO change this once we have a unique identifier from BE
    return value.displayId;
  }), 'rank', 'asc');
}

export const normalizeSubscriptions = (subscriptions: Array<any>) => {
  if (!subscriptions.length) {
    return null;
  }
  const platforms : any = {};
  const getSlackMembers = (sub:any) => {
    let channelMembers = [], qMembers = [];
    if (sub.channels) {
      channelMembers = sub.channels
        .map((ch:any) => ch.members)
        .flat()
        .filter((m:any) => m);
    }
    if (sub.allMembers) {
      qMembers = sub.allMembers
        .map((t:any) => t.users)
        .flat()
        .filter((m:any) => m);
    }
    return channelMembers.concat(qMembers);
  }
  subscriptions.forEach((sub:Subscription) => {
    const platformData: Subscription= { ...sub };
    platforms[sub.platform] = platforms[sub.platform] || [];
    platformData.email = sub.email;
    if (sub.platform === 'slack') {
      // add slack members
      platformData.members = getSlackMembers(sub);
      // @ts-ignore
      platformData.conversations = keyBy(sub.channels, 'conversation_id');
    }
    if (sub.platform === 'office-365') {
      if (sub.teams) {
        platforms.teams = platforms.teams || [];
        let token_status = platformData.teams_token_status || platformData.token_status;
        if (platformData.token_status !== 'valid' && platformData.teams_token_status !== platformData.token_status) {
          token_status = platformData.token_status;
        }
        platforms.teams.push({
          ...platformData,
          platform: 'teams',
          token_status,
        });
      }
      if (sub.o365) {
        platforms[sub.platform].push(platformData);
      }
    } else {
      platforms[sub.platform].push(platformData);
    }
  });
  subscriptionsData = { ...platforms };
  return platforms;
}

export const getQuerySubscriptions = (subscriptions:Record<string, any>) => {
  if (!subscriptions) {
    return [];
  }
  const copySubs = { ...subscriptions }

  return Object.keys(copySubs).map((key: string) => {
    const querySub = [ ...copySubs[key] ];
    /*if (key === 'gmail') {
      querySub.forEach(s => {
        s.email = undefined;
      })
    }*/
    if (key === 'slack') {
      return querySub.map(s => {
        if (!s.channels) {
          return [];
        }
        return s.channels.map((ch:any) => ({
            conversation_id : ch.conversation_id,
            team_id : s.team_id,
            platform: key,
          })
        )
      }).flat();
    }
    /*if (key === 'teams') {
      return querySub.map(s => {
        if (!s.teams) {
          return []
        }
        return s.teams.map((t:any) =>
          t.channels.map((ch:any) => ({
            team_id: t.team_id,
            channel_id: ch.channel_id,
            platform: key,
            email: s.email,
          }))
        ).flat();
      }).flat();
    }*/
    return querySub;
  }).flat();
};